var components
try {
  components = {
    uniLoadMore: function () {
      return import(
        /* webpackChunkName: "components/uni-load-more/uni-load-more" */ "@/components/uni-load-more/uni-load-more.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l1 = _vm.__map(_vm.page.items, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 = item.imgList && item.imgList.length > 0
    var l0 = g0
      ? _vm.__map(item.imgList, function (imgItem, imgIndex) {
          var $orig = _vm.__get_orig(imgItem)
          var m0 = _vm.style(200)
          return {
            $orig: $orig,
            m0: m0,
          }
        })
      : null
    return {
      $orig: $orig,
      g0: g0,
      l0: l0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }